var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoUsersFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 570.195,
    y1: 186.628,
    x2: 571.84,
    y2: 201.434,
    gradientTransform: "translate(-369.208 188.922) rotate(-19.56) scale(1 1.058)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8e77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8e77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 689.186,
    y1: 227.218,
    x2: 690.831,
    y2: 242.024,
    gradientTransform: "translate(1112.748 188.922) rotate(-160.44) scale(1 -1.058)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 96.753,
    y1: 211.368,
    x2: 107.393,
    y2: 211.368,
    gradientTransform: "translate(596.164 21.529) rotate(179.135) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M693.024,477.18c-21.232-167.858-155.522-297.244-318.024-297.244S78.208,309.322,56.976,477.18h636.048Z",
    style: {
      fill: "#eff7fc"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M318.905,214.15l-16.86-.98c-4.46-.26-8.7,1.92-11.09,5.68-2.47,3.88-5.4,8.55-6.6,10.66l-.168.308,8.302,6.302,1.476-4.26s10.26-2.44,10.76-5.11l.31-3.04.16-2.91.17-2.96,1.98-.03,11.5-.19c.86-.02,1.58-.67,1.69-1.53.12-.99-.62-1.89-1.63-1.94Z",
    style: {
      fill: "#ffcfc0"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252.858,178.04l.47,5.34c-11,4.95-21.6,11.91-21.6,11.91,0,0-7.34-10.65-11.24-19.3-3.16-7.01-3.02-18.54,10.32-22.45,1.59-.47,3.37-.83,5.36-1.06,13.57-1.56,19.893,6.72,22.523,13.19l-5.833,12.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.045,211.08c-1.27,1.2-3.09,2.09-5.7,2.09-4.15,0-6.89-2.25-8.57-4.41-.19-1.46-.38-2.82-.59-4.06-.05-.34-.1-.68-.16-1l1.1-.3c.1-.32.14-.66.11-1.01l-.17-2.24-.74-9.91-.44-5.19,11.23-.65,1.23,15.52.24,3.02c.01.12.03.24.06.35l1.33.26c.09.5.18,1.03.26,1.58.26,1.62.5,3.42.74,5.37.02.19.05.38.07.58Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.055,304.43c-4.85.55-9.54.7-13.96.61-.27-10.77-1.82-67.91-5.14-94.92-.06-.46-.12-.92-.18-1.36,1.68,2.16,4.42,4.41,8.57,4.41,2.61,0,4.43-.89,5.7-2.09,3.18,26.89,4.71,81.33,5.01,93.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M199.205,446.371h15.824l20.487-114.962c7.012,36.323,8.887,96.231,9.312,114.962h15.862c6.062-51.177-.887-121.226-3.812-146.433-.287-2.538-.537-4.618-.737-6.181-.262-2.162-.425-3.337-.425-3.337h-42.648l-.162,1.786-.675,7.568-13.024,146.597Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.692 452.153 214.004 452.153 214.516 449.262 215.029 446.371 199.205 446.371 198.955 449.262 198.692 452.153",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.827,446.371c.025.964.038,1.822.05,2.562.05,2.08.063,3.22.063,3.22h14.999c.112-.799.225-1.598.325-2.397.15-1.116.287-2.244.425-3.384h-15.862Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M242.99,475.949h40.948c-.2-1.269-.675-3.49-1.75-5.805-.05-.129-.112-.247-.175-.376l-10.612-6.205-9.35-5.464.426-4.053c.107-1.014-.741-1.893-1.824-1.893h-16.501l-.875,17.991-.287,5.805Z",
    style: {
      fill: "#30336b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.152,475.949h19.787c-.2-1.269-.675-3.49-1.75-5.805-.05-.129-.112-.247-.175-.376-1.1-2.268-2.787-4.571-5.362-6.158-1.95-1.21-3.7-1.034-5.25-.047-1.975,1.257-3.612,3.843-4.9,6.581-.962,1.998-1.75,4.089-2.35,5.805Z",
    style: {
      fill: "#161554"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.99,475.949h40.948c-.2-1.269-.675-3.49-1.75-5.805h-38.911l-.287,5.805Z",
    style: {
      fill: "#130f40"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.466,
    y1: 461.848,
    x2: 264.731,
    y2: 465.667,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.598,
    y1: 460.672,
    x2: 262.863,
    y2: 464.491,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.731,
    y1: 459.496,
    x2: 260.995,
    y2: 463.315,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M195.047,475.949h42.198c-.2-1.269-.675-3.49-1.75-5.805-.05-.129-.112-.247-.175-.376l-10.612-6.205-9.35-5.464.426-4.053c.107-1.014-.741-1.893-1.824-1.893h-16.501l-2.125,17.991-.287,5.805Z",
    style: {
      fill: "#30336b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.459,475.949h19.787c-.2-1.269-.675-3.49-1.75-5.805-.05-.129-.112-.247-.175-.376-1.1-2.268-2.787-4.571-5.362-6.158-1.95-1.21-3.7-1.034-5.25-.047-1.975,1.257-3.612,3.843-4.9,6.581-.962,1.998-1.75,4.089-2.35,5.805Z",
    style: {
      fill: "#161554"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.047,475.949h42.198c-.2-1.269-.675-3.49-1.75-5.805h-40.161l-.287,5.805Z",
    style: {
      fill: "#130f40"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.773,
    y1: 461.848,
    x2: 218.038,
    y2: 465.667,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 219.906,
    y1: 460.672,
    x2: 216.17,
    y2: 464.491,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.038,
    y1: 459.496,
    x2: 214.302,
    y2: 463.315,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 221.712,
    y1: 303.206,
    x2: 203.247,
    y2: 438.639,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.302,
    y1: 438.639,
    x2: 201.4,
    y2: 438.639,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.023,
    y1: 438.639,
    x2: 259.002,
    y2: 438.639,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.523,438.639s-.521-75.698-9.479-109.776",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M241.122,184.402l1.268,16.574c-6.498-2.328-10.086-7.662-12.058-10.734l-.446-5.189,11.236-.651Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.068,159.768c10.291.634,15.845,5.713,15.447,20.885-.056,2.117-.436,4.239-1.274,6.184-5.326,12.368-21.364,6.922-23.905-1.153-2.772-8.809-5.391-7.062-4.885-15.267.505-8.205,7.213-11.107,14.618-10.65Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M244.41,172.44s.009,6.379,5.159,6.746l-4.729,1.768",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.819,181.294c-.13-.008-.25-.091-.298-.221-.066-.177.023-.373.199-.439l3.565-1.333c-4.156-1.236-4.216-6.8-4.216-6.862,0-.188.152-.341.34-.341.189,0,.341.152.341.34,0,.248.073,6.066,4.842,6.407.16.012.291.132.313.291.023.158-.068.311-.218.368l-4.729,1.768c-.046.017-.094.024-.14.021Z",
    style: {
      fill: "#ff8e77"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.712,174.789c.089.668.475,1.167.863,1.115.388-.052.63-.635.541-1.302s-.475-1.167-.863-1.115c-.388.052-.63.635-.541,1.302Z",
    style: {
      fill: "#130f40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.791,174.789c.089.668.475,1.167.863,1.115.388-.052.63-.635.541-1.302s-.475-1.167-.863-1.115-.63.635-.541,1.302Z",
    style: {
      fill: "#130f40"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M261.441,165.337s-15.373,7.053-23.923-5.587c-.06,1.03-.35,3.38-1.99,5.75-1.52,2.18-3.41,3.26-4.33,3.72.27,1.55.49,3.87.08,6.62-.45,3-1.48,5.31-2.26,6.76-4.83-2.75-7.7-7.45-7.52-12.22.07-1.93.72-4.02,2.28-6.19l7.03-10.65c1.59-.47,3.37-.83,5.36-1.06,13.57-1.56,22.643,6.387,25.273,12.857Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.441,181.521s-2.717-6.443-6.889-3.938c-4.172,2.505,1.513,13.753,7.411,7.688l-.522-3.751Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.219,183.36c-.102-.006-.2-.058-.262-.149-2.113-3.116-2.916-3.159-3.109-3.094-.315.1-.45.87-.442,1.359.003.188-.147.343-.335.347-.195.003-.343-.147-.347-.334-.003-.176-.005-1.729.917-2.022.901-.282,2.131.784,3.88,3.362.106.155.065.368-.091.473-.064.044-.139.062-.212.058Z",
    style: {
      fill: "#ff8e77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.83,184.706c-.055-.003-.11-.02-.161-.052-.808-.511-1.28-1.153-1.403-1.909-.206-1.279.687-2.387.725-2.433.119-.144.333-.167.479-.047.145.119.167.333.049.479-.008.009-.739.923-.579,1.896.09.553.458,1.036,1.093,1.438.159.101.206.311.106.47-.069.109-.189.165-.309.158Z",
    style: {
      fill: "#ff8e77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.535,186.747c-.574,1.312-1.731,2.072-2.585,1.699s-1.081-1.739-.508-3.051c.574-1.312,1.731-2.072,2.585-1.699.854.373,1.081,1.739.508,3.051Z",
    style: {
      fill: "#ff8e77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.408,167.733s4.929-1,7.058,1.5",
    style: {
      fill: "none",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.97,169.733s2.437-3.209,4.875-2.292",
    style: {
      fill: "none",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.078,217.883h-8.489c-.919,0-1.606.958-1.418,1.978h0c.14.761.732,1.306,1.418,1.306h8.489c.8,0,1.449-.735,1.449-1.642h0c0-.907-.649-1.642-1.449-1.642Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.442,221.167h-8.435c-1.184,0-2.069.932-1.826,1.925h0c.181.74.943,1.271,1.826,1.271h8.435c1.03,0,1.866-.715,1.866-1.598h0c0-.883-.835-1.598-1.866-1.598Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.731,226.181h0c.163.699.851,1.2,1.649,1.2h6.91c.93,0,1.685-.676,1.685-1.51h0c0-.834-.754-1.51-1.685-1.51h-6.91c-1.069,0-1.868.881-1.649,1.819Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.802,221.172h-6.212c-.69,0-1.282-.548-1.413-1.315-.197-1.019.493-1.972,1.413-1.972h8.491",
    style: {
      fill: "#ffcfc0",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.627,224.361h-5.62c-.887,0-1.643-.526-1.83-1.271-.241-.986.646-1.917,1.83-1.917h8.072",
    style: {
      fill: "#ffcfc0",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.276,227.378h-4.896c-.801,0-1.484-.495-1.652-1.197-.218-.94.583-1.82,1.652-1.82h7.236",
    style: {
      fill: "#ffcfc0",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.683,219.725s6.552-4.911,11.728-6.096c.528-.121,1.064.16,1.247.67h0c.157.439.011.927-.365,1.202-.924.678-2.669,1.986-3.905,3.083-1.755,1.558-.963,4.32-5.354,7.707",
    style: {
      fill: "#ffcfc0",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.945,232.44c.09-9.03.05-16.85-.01-22,3.22-1.9,6.72-3.39,10.41-4.39l4.83-1.31,3.85-1.04c.86,5,1.63,12.09,2.29,20.23,2.4,29.18,3.55,71.95,3.78,81.11-17.33-.36-30.25-4.62-30.25-4.62,3.79-15.01,4.86-45.31,5.1-67.98Z",
    style: {
      fill: "#22a6b3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.085,250.98l.26,51.69c-3.47.81-6.91,1.37-10.29,1.76-.26-10.3-1.41-51.76-3.74-80.33-.68-8.3-1.46-15.51-2.34-20.55l4.61.89,3.29.63c3.47.67,6.65,2.11,9.36,4.15,1.24,10.06-.42,25.93-1.15,41.76Z",
    style: {
      fill: "#22a6b3"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M214.365,302.54l-3.81,1.45-3.77,1.44-4.39,1.67-4.55,1.73c-4.97-1.5-7.01-7.83-7.01-7.83-.4-.81-.8-1.8-1.2-2.92l10.19-3.07c.16,1.04.27,1.61.27,1.61l10.35,2.35c1.88.42,3.34,1.81,3.92,3.57Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.395,307.1l4.39-1.67.06,6.91c0,.88-.55,1.68-1.38,1.98-1.23.45-2.54-.34-2.77-1.59-.03.84-.57,1.59-1.37,1.88-1.23.45-2.57-.33-2.78-1.62l-.7-4.16,4.55-1.73Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.785,305.43l3.77-1.44.1,8.63v.02c0,.78-.5,1.48-1.24,1.75-1.2.44-2.48-.44-2.5-1.72l-.13-7.24Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.655,304.07l-.3,6.66c-.03.75-.51,1.4-1.22,1.65-1.19.44-2.46-.44-2.48-1.71l-.1-6.68,3.81-1.45c.16.49.27,1,.29,1.53Z",
    style: {
      fill: "#ffcfc0"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 202.704,
    y1: 312.525,
    x2: 202.319,
    y2: 306.822,
    style: {
      fill: "none",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.836,
    y1: 311.599,
    x2: 206.783,
    y2: 305.43,
    style: {
      fill: "none",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210.628,
    y1: 310.315,
    x2: 210.56,
    y2: 303.992,
    style: {
      fill: "none",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".25px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M275.015,246.59l-5.16-23.93c-1.18-5.49-4.3-10.21-8.62-13.44,1.24,10.06-.42,25.93-1.15,41.76l2.16,6.87.81,2.57c2.81,8.94,14.13,10.08,19.17,3.55.01,0,.01-.01.02-.02,2.9-3.344,7.702-15.169,9.571-19.936.469-1.196.103-2.553-.901-3.354l1.573-4.54-8.302-6.302-9.171,16.772Z",
    style: {
      fill: "#22a6b3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.855,269.11c-.01.21-.03.47-.06.78.02-.26.03-.52.06-.78Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.795,269.92v-.03c.02-.26.03-.52.06-.78.87-12.07,3.92-25.91,12.09-36.67.09-9.03.05-16.85-.01-22-6.77,4.01-11.83,10.17-15.98,17.03-14.051,23.249-10.048,57.289-5.316,70.614l10.191-3.074c-.173-1.136-.405-2.833-.624-4.979,1.108-1.034,1.604-2.568,1.3-4.053-.713-3.493-1.91-10.12-1.79-14.747.01-.46.04-.89.08-1.31Z",
    style: {
      fill: "#22a6b3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.315,223.93c-5.32-2.02-5.01-9.49-6.14-19.19l3.85-1.04c.86,5,1.63,12.09,2.29,20.23Z",
    style: {
      fill: "#158989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.085,250.98c.73-15.83,1.655-18.196,1.596-29.808",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.315,224.1c-.68-8.3-1.46-15.51-2.34-20.55l4.61.89c1.76,9.82,1.81,16.87-2.27,19.66Z",
    style: {
      fill: "#158989"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.635,
    y1: 291.67,
    x2: 197.22,
    y2: 290.42,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.345,
    y1: 236.076,
    x2: 288.22,
    y2: 240.045,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.515,331.409c2.58-14.114,4.9-22.895,4.9-22.895",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M395.259,179.32c.03-.07.08-.15.12-.23,0,0-.01.01-.03.04-.03.07-.06.13-.09.19Z",
    style: {
      fill: "#eb4d4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.443 437.004 355.693 452.42 365.693 448.837 361.85 435.254 350.443 437.004",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M373.143,451.078l-12.108,21.083h-4.985c-2.943-2.74-4.281-5.616-8.693-6.49,4.094-2.654,7.733-9.896,4.005-18.486l13.651-5.514,8.13,9.407Z",
    style: {
      fill: "#30336b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.229,454.238l-11.074,19.899c-.623,1.119-1.802,1.812-3.083,1.812h-19.384v-3.789h18.55c.492,0,.947-.263,1.192-.69l11.712-20.393,2.086,3.16Z",
    style: {
      fill: "#d1e7f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.411,475.949h-15.723s-2.436-6.565,0-10.013c.035-.061.079-.122.122-.183h.009c.69-.89,1.737-1.545,3.282-1.781h.017c5.762-.873,9.201,4.365,10.93,8.189.943,2.113,1.362,3.789,1.362,3.789Z",
    style: {
      fill: "#d1e7f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.958,451.744c1.328,1.73,3.324,2.427,4.459,1.556,1.135-.871.979-2.979-.349-4.71-1.327-1.73-3.324-2.427-4.459-1.556-1.135.871-.979,2.979.349,4.71Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 369.609,
    y: 447.587,
    width: 11.083,
    height: 9.667,
    transform: "translate(750.302 904.841) rotate(180)",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.609,293.92c0,52.75-8.75,156.233-8.75,156.233h-17.764l1.264-139.134-9.572,64.518,5.729,64.134-15.157,4.5-10.906-56.386c-2.518-8.928-2.641-18.362-.354-27.352l12.51-68.844,43,2.332Z",
    style: {
      fill: "#748798"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.029,293.64c20,6.89,52.22,3.45,52.22,3.45v-87.7c-6.55-4.19-12.56-6.02-18.68-5.97-9.39.07-16.47,1.22-22.47,3.67l-3.08,24.07-5.42,42.41-.09.69-2.48,19.38Z",
    style: {
      fill: "#8063b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.719,171.36l6.46,7.31-.47,5.34c10.06,4.53,19.79,10.74,21.37,11.75.72,1.82,3.09,2.66,3.09,2.66-.44-1.38,0-4.25,0-4.25.76,1.41,3.07,1.64,3.07,1.64-.88-.8-.74-3.33-.74-3.33,2.13,1.22,4.42,1.25,4.42,1.25-1.35-.65-4.2-5-.41-12.96l.03-.06c.21-.45.45-.91.72-1.39.03-.06.06-.12.09-.19.43-.85.83-1.69,1.2-2.51,3.16-7.01,3.02-18.54-10.32-22.45-1.59-.47-3.37-.83-5.36-1.06-11.24-1.29-19.6,5.75-23.63,11.88-1.31,1.98-1.08,4.59.48,6.37Z",
    style: {
      fill: "#fbb03b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.479,204.14c0,.04.01.37.38.77.29.3.84.71,1.91,1.05,1.13.35,2.81.63,5.34.63,4.81,0,7.38-.59,8.72-1.14.83-.33,1.2-.65,1.34-.8-.39-.11-.77-.22-1.16-.31v-.01l-1.1-.3c-.1-.32-.14-.66-.11-1.01l.17-2.24.74-9.91.44-5.19-11.23-.65-1.23,15.52-.24,3.02v.01c-1.37.08-2.69.19-3.96.33.01.07,0,.15-.01.23Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.916,185.036l-1.268,16.574c6.498-2.329,10.086-7.662,12.058-10.734l.446-5.189-11.236-.651Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.97,160.402c-10.291.634-15.845,5.713-15.447,20.886.056,2.117.436,4.239,1.274,6.184,5.327,12.368,21.364,6.922,23.905-1.152,2.772-8.809,5.391-7.062,4.885-15.267-.505-8.205-7.213-11.106-14.618-10.65Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M372.628,173.074s-.009,6.379-5.159,6.746l4.729,1.768",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.219,181.928c.13-.008.249-.091.298-.221.066-.176-.023-.373-.199-.439l-3.565-1.332c4.156-1.236,4.216-6.8,4.216-6.862,0-.188-.152-.34-.34-.341-.189,0-.341.152-.341.34,0,.248-.073,6.066-4.842,6.407-.16.012-.291.133-.313.291-.023.158.068.311.218.368l4.729,1.768c.046.018.094.024.14.021Z",
    style: {
      fill: "#ff8e77"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M366.326,175.423c-.089.667-.475,1.167-.863,1.115-.388-.052-.63-.635-.541-1.302.089-.668.475-1.167.863-1.115.388.052.63.635.541,1.302Z",
    style: {
      fill: "#130f40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.247,175.423c-.089.667-.475,1.167-.863,1.115-.388-.052-.63-.635-.541-1.302.089-.668.475-1.167.863-1.115.388.052.63.635.541,1.302Z",
    style: {
      fill: "#130f40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.52,160.385c.06,1.03.35,3.38,1.99,5.75,1.52,2.18,3.41,3.26,4.33,3.72-.27,1.55-.49,3.87-.08,6.62.45,3,1.48,5.31,2.26,6.76,4.83-2.75,7.7-7.45,7.52-12.22-.07-1.93-.72-4.02-2.28-6.19l-2.375-8.708s-.724-7.322-11.312-6.697c-10.588.625-17.713,5.688-21.776,9.5s-4.562,6.838,2.437,3.638c0,0-3.932,7.521,6.127,1.629,0,0,.193,9.287,13.158-3.803Z",
    style: {
      fill: "#fbb03b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.596,182.155s2.717-6.443,6.889-3.938c4.172,2.505-1.513,13.753-7.411,7.688l.522-3.751Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.818,183.995c.102-.006.2-.058.262-.149,2.113-3.116,2.916-3.159,3.109-3.094.315.1.45.87.442,1.359-.003.188.147.343.335.347.195.003.343-.147.347-.334.003-.176.005-1.728-.917-2.021-.901-.283-2.132.784-3.88,3.362-.106.155-.065.368.091.473.064.044.139.062.212.058Z",
    style: {
      fill: "#ff8e77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.208,185.34c.055-.003.11-.02.161-.052.808-.511,1.281-1.154,1.403-1.909.207-1.279-.687-2.386-.725-2.433-.119-.144-.333-.167-.479-.047-.145.119-.167.333-.049.479.008.009.739.923.579,1.896-.09.553-.458,1.036-1.093,1.438-.159.1-.206.311-.106.47.069.109.189.165.309.158Z",
    style: {
      fill: "#ff8e77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.63,168.367s-4.929-1-7.058,1.5",
    style: {
      fill: "none",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.068,170.367s-2.437-3.208-4.875-2.292",
    style: {
      fill: "none",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.362,164.187c-10.06,5.892-6.127-1.629-6.127-1.629,0,0-.898.446-1.791.746",
    style: {
      fill: "none",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.039,264.41l20.44,16.61,6.03-6.76.33-.37-.24-.32-16.57-21.6,21.99-20.81,2.37-2.24h37.8l4.06,3.96,24.28,23.71-20.34,22.41,8.69,9.56,21.92-22.03c5.43-5.45,5.96-14.1,1.23-20.18-14.66-18.84-25.84-30.61-35.78-36.96-2.8-1.79-5.5-3.15-8.15-4.11-.63-.23-1.26-.44-1.89-.62-.01-.01-.03-.02-.04-.01-.38.4-2.3,1.94-10.06,1.94-4.94,0-6.66-1.05-7.25-1.68-.37-.4-.38-.73-.38-.77.01-.08.02-.16.01-.23-.68.06-1.35.15-2,.24-4.29.59-8.01,1.56-11.39,2.94-7.39,3.01-13.14,7.98-19.57,15.33-5.41,6.17-11.7,13.35-16.91,19.28-5.86,6.67-5.22,16.82,1.42,22.71Z",
    style: {
      fill: "#8063b2"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M357.159,282.01l-2.54,1.67c-1.32,1.05-.65,3.18,1.03,3.28l4.99.3c.86-.17,1.67-.57,2.32-1.16l3.12-2.8c1.06-.94,1.32-2.49.64-3.74l-.18-.32-1.83-3.32-.56-1.01-1.76-3.17c-.17-.21-.38-.4-.6-.55-.65-.43-1.47-.57-2.24-.35l-10.71,3.05-6.36,7.13s7.1,5.14,14.68.99Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.973,286.028c1.487-1.167-1.924-5.29-2.737-6.089",
    style: {
      fill: "none",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.145,284.031c1.487-1.167-1.924-5.29-2.737-6.089",
    style: {
      fill: "none",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.276,271.754c4.968-1.391,12.375-1.456,16.483,1.502.524.377.688,1.202.391,1.845v.002c-.278.599-.876.856-1.409.615-2.151-.974-7.711-2.235-13.549.09l-1.917-4.053Z",
    style: {
      fill: "#ffcfc0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M366.662,276.154c.97.114,1.594,1.085,1.295,2.015-.2.621-.767,1.051-1.419,1.075l-1.209.045-1.161-3.428,2.495.293Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.539,
    y1: 279.24,
    x2: 364.709,
    y2: 275.92,
    style: {
      fill: "none",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.149,274.91l-1.76-3.17c-.17-.21-.38-.4-.6-.55",
    style: {
      fill: "none",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410.879,288.56l1.452,5.015c1.024,3.538-1.038,7.232-4.588,8.215l-3.241.898c-3.144.871-6.253-1.494-6.253-4.756v-10.352c0-2.629,1.389-5.063,3.652-6.401l1.475-.872,7.503,8.254Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.541,290.137l-1.341,10.984c-.096.79-.767,1.384-1.563,1.384h0c-.896,0-1.619-.746-1.573-1.641.093-1.799.026-4.679-1.092-6.572-1.729-2.927-2.346-6.736-.701-10.26",
    style: {
      fill: "none",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M404.342,472.548c-.101-.569-.227-1.113-.379-1.656-1.403-.645-4.742-2.289-8.408-4.767-4.527-3.06-9.546-7.422-11.999-12.771l-15.346-.617-.613,19.811h36.747Z",
    style: {
      fill: "#30336b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.342,472.548h-36.747l-.105,3.401h37.168c0-1.125-.101-2.276-.316-3.401Z",
    style: {
      fill: "#d1e7f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.658,475.949h-15.767c.796-2.15,2.149-4.704,4.388-7.511.797-.999,1.555-1.758,2.276-2.314,4.097-3.111,7.106.202,8.408,4.767.455,1.606.695,3.363.695,5.058Z",
    style: {
      fill: "#d1e7f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.844,465.162c0,2.03-1.079,3.675-2.41,3.675s-2.41-1.645-2.41-3.675,1.079-3.675,2.41-3.675,2.41,1.645,2.41,3.675Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 383.359,
    y1: 443.837,
    x2: 370.859,
    y2: 443.837,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.109,
    y1: 443.837,
    x2: 377.109,
    y2: 314.367,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.85,
    y1: 435.254,
    x2: 352.109,
    y2: 437.67,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.249,314.367l-9.842,53.455c-.927,5.033-1.043,10.182-.344,15.252l7.347,53.281",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M361.353,246.981c.01.249.026.497.052.749.032.342.081.688.139,1.034.643,3.747,2.704,7.019,5.805,9.216.307.216.62.42.94.614.187.11.378.22.569.32,2.067,1.115,4.351,1.69,6.687,1.69.804,0,1.615-.068,2.426-.207,1.79-.31,3.473-.94,4.981-1.851.191-.116.381-.236.565-.362,1.415-.953,2.658-2.161,3.673-3.592,2.197-3.104,3.053-6.874,2.413-10.621-.042-.242-.087-.481-.142-.717-.048-.226-.107-.449-.168-.672-1.651-6.015-7.058-10.208-13.186-10.437-.226-.01-.455-.013-.685-.006h-.003c-.74.006-1.489.071-2.242.2-2.471.423-4.735,1.46-6.622,3.011-.165.136-.326.275-.485.417-.782.701-1.489,1.499-2.113,2.377-1.848,2.61-2.746,5.692-2.604,8.838ZM361.989,246.558c-.052-2.865.808-5.66,2.497-8.043.594-.84,1.273-1.602,2.022-2.274.158-.142.32-.281.484-.417,1.793-1.463,3.944-2.449,6.293-2.849.633-.11,1.266-.171,1.893-.187.132-.003.268-.006.401-.006.094,0,.187,0,.281.003,5.85.123,11.054,4.035,12.734,9.707.068.22.129.443.181.669.074.3.139.607.191.917.61,3.579-.207,7.178-2.303,10.14-.998,1.412-2.229,2.594-3.634,3.515-.184.123-.375.239-.569.352-1.399.824-2.949,1.392-4.597,1.673-3.02.517-6.06.013-8.715-1.421-.191-.1-.381-.21-.568-.323-.291-.174-.575-.362-.856-.559-2.962-2.097-4.929-5.22-5.543-8.799-.077-.449-.132-.898-.161-1.347-.019-.249-.029-.501-.029-.749Z",
    style: {
      fill: "#9478d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.592,243.748c.591,2.413.643,4.997.145,7.746-.465,2.571-1.35,4.836-2.158,6.519-.1.203-.197.397-.291.581.187.11.378.22.569.32.097-.184.194-.378.291-.578.83-1.722,1.741-4.044,2.226-6.725.417-2.316.533-5.088-.187-7.998-.048-.207-.103-.41-.165-.617-.678-2.371-1.925-4.816-4.028-7.171-.142-.158-.287-.317-.439-.475-.165.136-.326.275-.485.417.152.155.3.313.439.475,1.899,2.1,3.204,4.4,3.918,6.89.061.203.116.41.165.617Z",
    style: {
      fill: "#9478d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.074,242.459c.026.213.055.423.09.63.491,3.208,1.67,5.976,2.917,8.156,1.796,3.13,3.976,5.495,5.378,6.838.178.171.342.326.491.462.191-.116.381-.236.565-.362-.145-.129-.31-.281-.488-.452-1.363-1.289-3.582-3.657-5.398-6.829-1.496-2.61-2.449-5.243-2.856-7.892-.035-.21-.068-.423-.087-.633-.397-3.188-.007-6.393,1.173-9.594.077-.213.158-.426.245-.64-.226-.01-.455-.013-.685-.006h-.003c-.087.216-.165.436-.239.649-1.24,3.498-1.46,6.758-1.105,9.671Z",
    style: {
      fill: "#9478d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.353,246.981c.01.249.026.497.052.749.2-.149.407-.291.614-.423,2.587-1.722,5.543-2.846,8.573-3.56.197-.048.394-.09.594-.136.988-.213,1.987-.388,2.978-.523.203-.029.407-.055.61-.078,5.417-.669,10.637-.278,14,.149.239.032.465.061.685.094-.048-.226-.107-.449-.168-.672-.223-.032-.455-.061-.698-.09-3.408-.42-8.557-.772-13.906-.113-.204.026-.41.052-.614.081-1.017.139-2.038.316-3.053.536-.2.045-.397.09-.594.136-2.965.698-5.866,1.786-8.437,3.427-.213.132-.426.274-.636.423Z",
    style: {
      fill: "#9478d1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M368.489,204.15c0,.42.11,1.19.78,1.98,1.37,1.63,4.35,2.46,8.84,2.46,10.04,0,11.72-2.48,11.99-3.31.01-.01.02-.03.02-.04.16-.53-.14-1.09-.67-1.25-.49-.15-1.02.11-1.21.58-.01.01-.03.04-.07.08-.38.4-2.3,1.94-10.06,1.94-4.94,0-6.66-1.05-7.25-1.68-.37-.4-.38-.73-.38-.77.01-.08.02-.16.01-.23-.02-.45-.36-.82-.83-.9-.54-.09-1.06.3-1.15.84-.01.03-.02.14-.02.3Z",
    style: {
      fill: "#9478d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.399,188.5s2.13-2.66,7.57-.51c-.11-.14-1.21-1.51-2.51-2.65-1.04-.92-2.22-1.7-3.14-1.59-.79.09-1.26.77-1.53,1.59-.47,1.38-.39,3.16-.39,3.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.399,188.5s2.13-2.66,7.57-.51c-.07-.09-.54-.67-1.2-1.38-.39-.4-.83-.85-1.31-1.27h-4.67c-.14.41-.23.85-.29,1.27-.14,1.01-.1,1.89-.1,1.89Z",
    style: {
      fill: "#ff8e77"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M531.033,251.545c-.458-8.792-8.485-5.339-8.485-5.339,0,0,2.348-7.136-2.521-7.392-4.869-.255-5.665-3.811-3.294-16.25h0c2.599-9.017.059-17.993-6.767-17.097,0,0-3.023-6.32-15.249-6.553-13.861-.264-21.102,19.549-15.437,29.051l-.015.002c.063.089.113.173.173.26.101.158.203.315.311.467,6.302,9.765-4.711,11.38-7.009,14.458-2.354,3.153-.321,6.081-.321,6.081,0,0-5.223-.936-7.379,5.395-2.156,6.331,4.418,9.594,4.418,9.594,0,0-8.647.247-7.739,7.8.908,7.553,7.667,6.033,7.667,6.033-1.12,3.565.088,7.256,4.113,7.25,4.025-.006,6.091-6.176,6.091-6.176,0,0-1.626,5.404,3.977,7.151,5.603,1.747,9.203-8.932,9.203-8.932,0,0,5.984,8.859,12.478,5.814,6.494-3.045,2.01-11.77,2.01-11.77,0,0,13.161,6.166,17.254-1.375,4.093-7.541-1.865-9.583-1.865-9.583,0,0,8.844-.098,8.386-8.89Z",
    style: {
      fill: "#30336b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.398 450.489 467.042 455.112 471.088 440.601 457.035 437.124 455.398 450.489",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.76,252.666c-1.419-8.269,3.995-13.512,5.809-15.002l13.79,3.528c.638,3.286,3.214,11.375,13.216,12.973,12.165,1.948,16.78-8.754,16.484-17.301l1.849-.997,8.655-4.678c.189,3.044,1.436,9.472,8.457,12.605l-3.851,2.891c-9.804,7.353-10.172,27.132-5.539,42.269l-30.714,6.626c-.009-.539-.036-1.068-.063-1.571-.431-7.973-2.496-11.878-4.085-13.126-5.342-4.166-9.786-12.453-8.646-23.837l-15.361-4.381Z",
    style: {
      fill: "#bb3030"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.364,439.311l-11.034,3.959-16.43-44.603c-1.194-4.139-1.867-8.421-1.993-12.731l-3.537-48.93-21.413,57.433-12.866,46.165-14.06-3.483,6.32-51.579c2.254-11.079,24.223-63.87,25.956-71.815.7-3.968,1.149-7.506,1.392-10.657l33.829-6.635c.395.817.808,1.607,1.239,2.361.009.018.018.027.027.045.162.287.332.575.503.853.018.027.036.063.054.09,8.763,14.993,11.483,29.574,0,91.702l12.013,47.826Z",
    style: {
      fill: "#30336b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "527.33 443.267 532.663 457.743 542.988 457.743 538.361 439.315 527.33 443.267",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.575,254.166c-10.002-1.598-12.578-9.687-13.216-12.973l.638.162,7.362,1.885c.736.189,1.454-.368,1.454-1.122l.027-3.573.063-10.729,10.639.189-.063,9.149-.018,2.945c-.009.889.934,1.454,1.715,1.032l7.883-4.265c.296,8.547-4.318,19.249-16.484,17.301Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.875,227.973l.198,13.049c7.417-.994,9.759-5.039,10.471-8.46l-.03-4.75-10.639.161Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M498.16,203.069c-9.262-1.166-15.058,2.418-17.254,15.984-.307,1.893-.325,3.845.094,5.716,2.659,11.899,17.844,9.751,21.462,2.994,3.947-7.371,5.983-5.376,6.913-12.761.93-7.385-4.55-11.094-11.214-11.933Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.049,214.514c-.13.682.088,1.297.485,1.372.398.076.825-.416.955-1.099s-.088-1.297-.485-1.372c-.398-.076-.825.416-.955,1.099Z",
    style: {
      fill: "#130f40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.361,215.812c-.13.682.088,1.297.485,1.372.398.076.825-.416.955-1.099.13-.682-.088-1.297-.485-1.373-.398-.076-.825.416-.955,1.099Z",
    style: {
      fill: "#130f40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.151,225.239s-2.915-6.275.31-12.274c0,0-11.639-3.478-10.994-13.323,0,0,13.663-.247,18.444,10.099,4.781,10.345-7.761,15.498-7.761,15.498Z",
    style: {
      fill: "#30336b"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M492.166,213.613s-1.08,5.673-5.724,5.135l3.91,2.368",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.314,221.422c.117.015.237-.039.302-.146.088-.146.042-.336-.104-.424l-2.947-1.785c3.905-.401,4.894-5.341,4.904-5.396.032-.167-.078-.328-.245-.36-.168-.033-.329.078-.361.245-.042.22-1.085,5.385-5.385,4.886-.145-.017-.281.069-.328.206-.047.137.008.288.132.364l3.91,2.368c.038.023.08.037.121.042Z",
    style: {
      fill: "#ff8e77"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M503.067,224.041s3.5-5.275,6.791-2.345c3.291,2.93-3.659,11.982-7.886,5.594l1.095-3.249Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.735,226.051c.092.011.188-.018.258-.089,2.404-2.417,3.125-2.32,3.286-2.23.264.142.254.85.165,1.283-.034.167.073.33.24.365.173.035.33-.073.365-.239.032-.156.295-1.537-.476-1.953-.754-.403-2.028.339-4.017,2.339-.12.121-.12.316.001.436.05.05.114.079.179.087Z",
    style: {
      fill: "#ff8e77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.745,227.482c.05.006.102,0,.152-.019.805-.319,1.333-.811,1.569-1.463.399-1.103-.21-2.239-.236-2.287-.081-.148-.268-.204-.418-.123-.149.081-.205.269-.124.418.005.01.502.946.196,1.785-.173.477-.582.845-1.214,1.095-.158.063-.236.242-.173.401.043.108.14.179.249.192Z",
    style: {
      fill: "#ff8e77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.319,212.231s3.142-2.057,6.172-.524",
    style: {
      fill: "none",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.493,212.68s-1.796-3.629-3.928-2.619",
    style: {
      fill: "none",
      stroke: "#130f40",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.575,225.939c0,1.58-1.751,2.864-3.905,2.864s-3.896-1.284-3.896-2.864c0-.898.566-1.697,1.454-2.218.664-.395,1.517-.637,2.442-.637,1.787,0,3.304.889,3.753,2.083.099.242.153.503.153.772Z",
    style: {
      fill: "#ff8e77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.422,225.167h-5.683s-.512-1.445-.512-1.445c.664-.395,1.517-.637,2.442-.637,1.787,0,3.304.889,3.753,2.083Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M547.609,471.728h-33.278s.329-3.048.329-3.048c.221-2.051,1.719-3.737,3.734-4.178,3.431-.751,8.738-2.503,12.319-6.447v-.011l-.692-2.3c-.319-1.062.33-2.171,1.412-2.412l11.735-2.613s.515,1.184,1.184,3.169c1.173,3.443,2.851,9.309,3.191,15.57l.066,2.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M541.415,475.949v-3.366s-4.225,3.366-4.225,3.366h-23.142c0-1.019.092-3.206.286-4.225h33.276s.103,4.225.103,4.225h-6.298Z",
    style: {
      fill: "#130f40"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M528.755,464.35c-.026,0-.051-.009-.071-.029l-2.642-2.603c-.039-.039-.04-.102,0-.142.039-.039.103-.04.142,0l2.643,2.603c.039.039.04.102,0,.142-.02.02-.046.03-.071.03Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M530.88,463.393c-.025,0-.051-.009-.071-.029l-2.895-2.853c-.039-.038-.04-.102,0-.142.039-.039.103-.04.142,0l2.895,2.853c.039.039.04.102,0,.142-.02.02-.046.03-.071.03Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M532.579,461.966c-.026,0-.051-.009-.071-.029l-2.895-2.852c-.039-.038-.04-.102,0-.142.039-.039.103-.04.142,0l2.895,2.852c.039.039.04.102,0,.142-.02.02-.046.03-.071.03Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M525.358,465.351c-.049,0-.092-.036-.099-.086-.008-.055.03-.106.085-.114.091-.013,9.138-1.378,8.86-7.088-.003-.055.04-.102.096-.105.051.003.103.04.105.096.287,5.891-8.939,7.284-9.032,7.297-.005,0-.009,0-.014,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M537.283,188.465v-.005s5.076-6.859,5.076-6.859c1.121-1.428,1.722-3.196,1.703-5.011l-.132-12.827c-.005-.482-.364-.887-.842-.949-.544-.071-1.038.325-1.088.871l-1.109,12.096-3.255-12.556c-.124-.477-.612-.761-1.088-.634-.43.115-.708.533-.649.974l1.605,11.941-3.424-8.291c-.206-.5-.773-.745-1.278-.553-.49.186-.753.72-.602,1.222l2.728,9.061-4.851-6.466c-.29-.386-.84-.459-1.22-.162-.323.253-.423.699-.238,1.066l3.253,6.451s-2.745,4.564-.759,11.792",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.425,193.552v-.005s-5.076-6.859-5.076-6.859c-1.121-1.428-1.722-3.196-1.703-5.012l.132-12.827c.005-.482.364-.887.842-.949.544-.071,1.038.324,1.088.871l1.109,12.096,3.255-12.556c.124-.477.612-.761,1.088-.634.43.115.708.533.649.974l-1.605,11.941,3.424-8.291c.206-.5.773-.745,1.278-.553.49.186.753.72.602,1.222l-2.728,9.061,4.851-6.466c.29-.386.84-.459,1.22-.162.323.253.423.699.238,1.066l-3.253,6.451s2.745,4.564.759,11.792",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.571,237.661l-19.7-5.043,3.726-37.905-6.168-1.158-10.011,35.239c-2.155,7.811,1.877,15.999,9.382,19.033l16.963,4.839c-1.421-8.267,3.994-13.511,5.807-15.005Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.374,220.3l-11.088-31.836-6.177,1.158,4.318,34.619-12.861,6.948c.183,3.042,1.433,9.472,8.455,12.604l12.45-9.344c4.363-3.277,6.303-8.87,4.902-14.149Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M459.895,475.949v-3.366s-4.225,3.366-4.225,3.366h-23.142c0-1.019.092-3.206.286-4.225h33.276s.103,4.225.103,4.225h-6.298Z",
    style: {
      fill: "#130f40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.549,465.035c0,1.838.977,3.328,2.183,3.328s2.183-1.49,2.183-3.328c0-1.838-.977-3.328-2.183-3.328s-2.183,1.49-2.183,3.328Z",
    style: {
      fill: "#fff"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M465.799,462.401l.296,9.32h-33.278s.318-3.037.318-3.037c.23-2.072,1.754-3.75,3.794-4.2,3.629-.8,9.353-2.719,12.895-7.16l.809-4.273c.351-1.857,2.183-3.043,4.022-2.605l13.25,3.163c.413.099.653.53.518.933l-2.623,7.859Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M447.235,464.351c-.025,0-.051-.009-.071-.029l-2.643-2.604c-.039-.039-.04-.102,0-.142.039-.038.103-.04.142,0l2.643,2.604c.039.039.04.102,0,.142-.02.02-.046.03-.071.03Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M449.36,463.393c-.025,0-.051-.009-.071-.029l-2.895-2.852c-.039-.039-.04-.102,0-.142.039-.039.102-.041.142,0l2.895,2.852c.039.039.04.102,0,.142-.02.02-.046.03-.071.03Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M451.21,461.966c-.025,0-.051-.009-.071-.029l-2.895-2.853c-.039-.039-.04-.102,0-.142.039-.039.103-.041.142,0l2.895,2.853c.039.039.04.102,0,.142-.02.02-.046.03-.071.03Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M443.838,465.35c-.049,0-.093-.036-.1-.086-.008-.055.031-.106.086-.114.091-.013,9.138-1.378,8.86-7.088-.002-.055.04-.102.096-.105.055.002.103.04.105.096.287,5.891-8.939,7.284-9.032,7.297-.005,0-.009,0-.014,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M490.699,303.069c.215-2.792.278-5.279.215-7.488l30.714-6.626c.826,2.666,1.796,5.189,2.9,7.479l-33.829,6.635Z",
    style: {
      fill: "#ffcfc0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460.614,
    y1: 432.829,
    x2: 470.041,
    y2: 435.298,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 527.884,
    y1: 437.124,
    x2: 534.411,
    y2: 435.298,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "465.328 434.063 474.53 387.714 493.833 332.05",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.298,304.184s6.961,9.686,6.96,29.213c-.001,16.109-4.737,45.201-6.395,54.893-.368,2.149-.24,4.348.374,6.44l12.248,41.387",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 493.159,
    y1: 308.146,
    x2: 525.368,
    y2: 303.069,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 505.37,
    y1: 337.006,
    x2: 504.606,
    y2: 324.98,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".25px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M275.175,145.837c.003-1.065.29-1.869.862-2.413.572-.544,1.403-.814,2.494-.812,1.052.003,1.866.283,2.442.842.575.56.862,1.359.86,2.399-.003,1.002-.296,1.79-.881,2.366-.585.575-1.397.862-2.436.859-1.065-.003-1.889-.287-2.471-.852-.582-.565-.871-1.362-.869-2.389ZM280.878,139.346l-4.641-.011-.925-18.584,6.58.016-1.015,18.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.17,59.047h-57.548c-5.229,0-9.467,4.239-9.467,9.468v39.355c0,5.229,4.239,9.468,9.467,9.468h16.064l12.71,12.71,12.711-12.71h16.063c5.229,0,9.468-4.239,9.468-9.468v-39.355c0-5.229-4.239-9.468-9.468-9.468Z",
    style: {
      fill: "#007583"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.585,89.041c0-13.145,7.175-19.978,14.81-19.978s14.812,6.833,14.812,20.036-7.177,19.978-14.812,19.978-14.81-6.83-14.81-20.036ZM387.047,89.041c0,9.991,4.076,13.607,7.348,13.607s7.348-3.616,7.348-13.607c0-9.931-4.132-13.547-7.348-13.547s-7.348,3.616-7.348,13.547Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUsersFound);
export default __webpack_public_path__ + "static/media/NoUsersFound.0294c6f0df30d8c1bd06386d9697d4a8.svg";
export { ForwardRef as ReactComponent };